import { isPatientApp } from '@/config/constants';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  maxDeviceInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 16,
    maxWidth: '90%',
  },
  maxDeviceListContainer: {},
  maxDeviceListTitle: {
    fontSize: 18,
    fontFamily: 'InterSemiBold',
    marginBottom: 12,
  },
  stayLoggedInText: {
    fontFamily: isPatientApp ? '' : 'InterSemiBold',
    fontSize: 14,
    fontWeight: isPatientApp ? 400 : 600,
    marginBottom: 1,
  },
  therapistWelcomeText: {
    fontSize: 22,
    fontWeight: '700',
    fontFamily: 'InterSemiBold',
    textAlign: 'center',
    marginBottom: 22,
    paddingTop: 22,
  },
  therapistSingleButtonContainer: {
    width: '100%',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    marginTop: 10,
  },
  therapistMultipleButtonsContainer: {
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginTop: 10,
  },
  layoutChildrenContainer: {
    maxWidth: 850,
    width: '100%',
    backgroundColor: 'white',
    borderRadius: 24,
    overflow: 'hidden',
  },
  stayLoggedInWrapper: { alignItems: 'flex-start', padding: 0, margin: 0 },
  stayLoggedInContainer: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    padding: 0,
    margin: 0,
  },
});
